var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLyricsImageOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 25,
    viewBox: "0 0 36 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12L18.7071 11.2929L19.4142 12L18.7071 12.7071L18 12ZM9 13C8.44771 13 8 12.5523 8 12C8 11.4477 8.44771 11 9 11V12V13ZM14 8L14.7071 7.29289L18.7071 11.2929L18 12L17.2929 12.7071L13.2929 8.70711L14 8ZM18 12L18.7071 12.7071L14.7071 16.7071L14 16L13.2929 15.2929L17.2929 11.2929L18 12ZM18 12V13H9V12V11H18V12Z",
    fill: "#656565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1479 2.97119L35.3735 20H32.3828L30.5273 15.0195H24.3994C24.1146 15.8415 23.8135 16.6756 23.4961 17.522C23.1868 18.3602 22.8898 19.1862 22.605 20H19.6021L25.8276 2.97119H29.1479ZM27.4756 6.54785L25.3027 12.6025H29.624L27.4756 6.54785Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLyricsImageOn);
export default __webpack_public_path__ + "static/media/lyrics-image-on.7931cc8cc6f6a85ffdea7ac7e557426d.svg";
export { ForwardRef as ReactComponent };